export default __webpack_public_path__ + "static/media/service1.200c262e.png";